// extracted by mini-css-extract-plugin
module.exports = {"input":"_2787e5dfdf--input--2B6lc","postfix":"_2787e5dfdf--postfix--1lZG5"};